import { STRINGS } from '@/strings/strings';
import type { SeriesPlan } from '@/features/series/types';

interface SeriesPlanCardProps {
  plan: SeriesPlan;
}

/**
 * Read-only display of the single generated season plan: a heading, the season
 * arc, the episode count, and the episode list (number + title + teaser). No
 * selection — the single-plan redesign replaced the 3-variant carousel, so the
 * plan flows straight into the confirm block below it.
 */
export function SeriesPlanCard({ plan }: SeriesPlanCardProps) {
  const S = STRINGS.series.builder;
  const episodes = plan.episodes;

  return (
    <div className="flex w-full flex-col items-start gap-2 rounded-lg border-[1.5px] border-dream-navy/15 bg-dream-white p-4 text-left">
      <span className="text-xs font-medium text-dream-navy/50">{S.planHeading}</span>

      {plan.seasonTitle.trim() && (
        <span className="text-lg font-bold text-dream-navy">{plan.seasonTitle}</span>
      )}

      {plan.seasonArc.trim() && (
        <p className="text-sm leading-relaxed text-dream-navy/80">{plan.seasonArc}</p>
      )}

      <span className="text-xs font-medium text-dream-navy/60">
        {S.variantEpisodeCount.replace('{count}', String(episodes.length))}
      </span>

      <ul className="mt-1 w-full space-y-2">
        {episodes.map((ep) => (
          <li key={ep.episodeNumber} className="text-sm text-dream-navy">
            <span className="font-semibold">
              {ep.episodeNumber}. {ep.title}
            </span>
            {ep.teaser?.trim() && <span className="block text-dream-navy/70">{ep.teaser}</span>}
          </li>
        ))}
      </ul>
    </div>
  );
}
